import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import useCommonTodo from '@/views/apps/todo/useCommonTodo'

export default function useBehaviourAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const { uploadFileToS3 } = useCommonTodo()
  const userData = store.state?.userStore?.userData
  const behaviour = ref({})
  const isSubmitting = ref(false)
  const collection = 'behaviour'

  const saveImgAWS = (imgFile) => {
    const destinationFolder = `${userData.client.$oid}/behaviours`
    return new Promise((resolve, reject) => {
      uploadFileToS3(imgFile, destinationFolder)
        .then((key) => resolve(key))
        .catch((err) => reject(err))
    })
  }

  const create = async (data, imgFile) => {
    isSubmitting.value = true

    let imageKey = null
    if (imgFile) {
      try {
        imageKey = await saveImgAWS(imgFile)
      } catch (error) {
        console.log(error)
      }
    }

    const payload = {
      client_id: oid(userData.client.$oid),
      name: data.name?.value || '',
      value_id: data.value_id?.value ? oid(data.value_id.value) : null,
      description: data.description?.value || '',
      imageKey,
    }

    try {
      await createItem({ collection, payload })
      showSuccessMessage(i18n.t('message.behaviour_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.behaviour_add_error'))
    } finally {
      router.push({ name: 'organization-behaviour-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    behaviour,
    isSubmitting,
  }
}
